import { RefObject, useEffect, useRef } from 'react';
import { useIntersectionObserver } from 'src/hooks/use-intersection-observer';
import { EnrollmentSteps } from 'src/payments/constants';
import { EnrollmentContexts, useDutchiePayAnalytics } from './use-dutchie-pay-analytics';

type UseTrackEnrollmentStepViewedProps = {
  step: EnrollmentSteps;
  context?: EnrollmentContexts;
  threshold?: number;
};
// Example usage:
// const ref = useTrackEnrollmentStepViewed({ step: EnrollmentSteps.ACCOUNT_LINK, context: EnrollmentContexts.INSTORE });
// return <div ref={ref}>...</div>;
export const useTrackEnrollmentStepViewed = ({
  step,
  context,
  threshold = 0.1,
}: UseTrackEnrollmentStepViewedProps): RefObject<HTMLDivElement> => {
  const { trackEnrollmentStepViewed } = useDutchiePayAnalytics();
  const ref = useRef<HTMLDivElement>(null);
  const entry = useIntersectionObserver(ref, { threshold, freezeOnceVisible: true });

  useEffect(() => {
    if (entry?.isIntersecting) {
      trackEnrollmentStepViewed({ step, context });
    }
  }, [entry?.isIntersecting, trackEnrollmentStepViewed, step, context]);

  return ref;
};
